<pep-message-dialog [title]="title"
  [showCancelButton]="true"
  [acceptButtonText]="'Upload starten'"
  [valid]="form?.valid"
  [disabled]="isLoading"
  (pushAccept)="save()"
  (pushCancel)="closeDialog()"
  (pushClose)="closeDialog()">
  <div>
    <div class="actions">
      <button mat-icon-button (click)="closeDialog()" class="btn btn-outline-primary renew"
        ngbTooltip="Dialog schließen" container="body" tooltipClass="myTooltip" triggers="hover">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div>
      <mat-form-field [floatLabel]="'always'" style="width: 16rem;" class="edit">
        <mat-label>Auswahl Typ</mat-label>
        <mat-select [compareWith]="compareFn"
          name="fileUploadType" [(ngModel)]="selectedFileUploadType" (selectionChange)="updateFileUploadType($event)">
          <mat-option value="2">Firmware</mat-option>
          <mat-option value="1">Setup</mat-option>
          <mat-option value="0">Zertifikat</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <form #form="ngForm">
      @if (selectedFileUploadType == 2) {
        Bitte wähle eine Installationsdatei für die Firmware aus:
        <div class="form-group">
          <div class="flex-item" style="width: auto;">
            <button mat-button class="pep-button" (click)="fileUpload.click()">
              <mat-icon>post_add</mat-icon>
              Datei auswählen
            </button>
            <input type="file" id="file"
              (change)="handleFile($event.target.files)" accept=".dfz" [hidden]="true" #fileUpload>
              <input type="text" id="filename" name="filename" required [ngModel]="fileToUpload?.name"
                [hidden]="true">
              </div>
              @if (fileToUpload) {
                <div>
                  {{fileToUpload.name}}
                </div>
              }
              <div style="margin-top: 20px;">
                <mat-form-field [floatLabel]="'always'"
                  class="edit middleHeight" style="margin-bottom: 0px; width: 16rem;">
                  <mat-label>Auswahl Terminals</mat-label>
                  <mat-select panelClass="EmployeeFilter__MatSelect" multiple
                    [required]="true" [compareWith]="compareFn"
                    name="terminals" [(ngModel)]="selectedDevices">
                    <div class="clickable" (click)="selectAllTerminals($event)" style="padding-left: 5px;">
                      <mat-checkbox class="mat-option all-option" [checked]="allTerminalsSelected">
                        Alle
                      </mat-checkbox>
                    </div>
                    <mat-divider></mat-divider>
                    @for (terminal of allTerminals; track trackByFn($index, terminal)) {
                      <mat-option [value]="terminal">
                        {{terminal.serialNumber}}, {{terminal.name}} ({{terminal.shop?.name}})
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }

          @if (selectedFileUploadType == 0) {
            Bitte wähle eine Zertifikatsdatei aus:
            <div class="form-group">
              <div class="flex-item" style="width: auto;">
                <button mat-button class="pep-button" (click)="fileUpload.click()">
                  <mat-icon>post_add</mat-icon>
                  Datei auswählen
                </button>
                <input type="file" id="file"
                  (change)="handleFile($event.target.files)" accept="*" [hidden]="true" #fileUpload>
                  <input type="text" id="filename" name="filename" required [ngModel]="fileToUpload?.name"
                    [hidden]="true">
                  </div>
                  @if (fileToUpload) {
                    <div>
                      {{fileToUpload.name}}
                    </div>
                  }
                </div>
                @if (selectedFileUploadType == 0) {
                  <div class="notice">
                    Hinweis: Das Zertifikat wird auf allen Terminals aufgespielt!
                  </div>
                }
              }

              @if (selectedFileUploadType == 1) {
                Bitte wähle eine Setupdatei aus:
                <div class="form-group">
                  <div class="flex-item" style="width: auto;">
                    <button mat-button class="pep-button" (click)="fileUpload.click()">
                      <mat-icon>post_add</mat-icon>
                      Datei auswählen
                    </button>
                    <input type="file" id="file"
                      (change)="handleFile($event.target.files)" accept="*" [hidden]="true" #fileUpload>
                      <input type="text" id="filename" name="filename" required [ngModel]="fileToUpload?.name"
                        [hidden]="true">
                      </div>
                      @if (fileToUpload) {
                        <div>
                          {{fileToUpload.name}}
                        </div>
                      }
                      <div style="margin-top: 20px;">
                        <mat-form-field [floatLabel]="'always'"
                          class="edit middleHeight" style="margin-bottom: 0px; width: 16rem;">
                          <mat-label>Auswahl Terminals</mat-label>
                          <mat-select panelClass="EmployeeFilter__MatSelect" multiple
                            [required]="true" [compareWith]="compareFn"
                            name="terminals" [(ngModel)]="selectedDevices">
                            <div class="clickable" (click)="selectAllTerminals($event)" style="padding-left: 5px;">
                              <mat-checkbox class="mat-option all-option" [checked]="allTerminalsSelected">
                                Alle
                              </mat-checkbox>
                            </div>
                            <mat-divider></mat-divider>
                            @for (terminal of allTerminals; track trackByFn($index, terminal)) {
                              <mat-option [value]="terminal">
                                {{terminal.serialNumber}}, {{terminal.name}} ({{terminal.shop?.name}})
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  }

                </form>

              </div>
            </pep-message-dialog>
